(() => {
  const initializeSlider = (root) => {
    if (!root || root.dataset.tabSliderReady === 'true') return;

    const viewport = root.querySelector('[data-tab-slider-viewport]');
    const previousButton = root.querySelector('[data-tab-slider-prev]');
    const nextButton = root.querySelector('[data-tab-slider-next]');

    if (!viewport || !previousButton || !nextButton) return;

    root.dataset.tabSliderReady = 'true';

    const updateButtons = () => {
      const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previousButton.disabled = viewport.scrollLeft <= 2;
      nextButton.disabled = viewport.scrollLeft >= maximumScroll - 2;
    };

    const getScrollDistance = () => {
      const card = viewport.querySelector('.tab-product-tile');
      if (!card) return viewport.clientWidth * 0.8;

      const track = viewport.querySelector('.tab-product-slider__track');
      const gap = track ? Number.parseFloat(window.getComputedStyle(track).columnGap) || 0 : 0;
      return (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(viewport.clientWidth / card.getBoundingClientRect().width));
    };

    previousButton.addEventListener('click', () => {
      viewport.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      viewport.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateButtons, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', updateButtons, { passive: true });
    }

    updateButtons();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-tab-slider]').forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
